export default {"src":"/_next/static/media/menu-icon.fb4fc853.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};